// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1A3bR","ranges":"BmiRanges_ranges__2_2DR"};